import { C } from "../../../common/component";
import { Icon, IconHelper } from "../../../common/icon-helper";
import { Txt } from "../../../common/text";
import { FileInfo } from "./file-info";
import { FileProgressControls } from "./file-progress-controls";
import { ImagePreview } from "./image-preview";

export class FileControl
{
    private readonly file: FileInfo;
    private readonly onChange: () => void;
    private isControlRemoved: boolean;

    constructor(file: FileInfo, onChange: () => void)
    {
        this.file = file;
        this.onChange = onChange;
    }

    private container: JQuery;
    private progressControls: FileProgressControls;
    private imagePreview: ImagePreview;

    appendTo(parent): void
    {
        this.container = C.div.css("margin-bottom", "5px").appendTo(parent);
        const inputGroup = C.div.addClass("w-input-group").appendTo(this.container);

        this.progressControls = new FileProgressControls(inputGroup, this.container);

        // The filename field is disabled and so receives no mouse events; wrap it in
        // its own cell and anchor the image preview there, so the preview appears when
        // hovering the filename only — not the clear button.
        const titleCell = C.span.addClass("w-file-title-cell").appendTo(inputGroup);
        this.imagePreview = new ImagePreview(titleCell[0]);
        C.input.attr("type", "text").addClass("w-form-control").attr("disabled", "disabled")
            .css("cursor", "default").val(this.file.getFileName()).appendTo(titleCell);

        const clearButtonContainer = C.span.addClass("w-input-group-btn").appendTo(inputGroup);
        const clearButton = C.button.addClass("w-button")
            .attr("type", "button")
            .click(() => this.remove())
            .appendTo(clearButtonContainer);
        IconHelper.addIconWithText(clearButton, Icon.remove, Txt.remove);

        if (this.file.hasUploader())
        {
            this.onProgress();
            this.file.getUploader().upload(() => this.onProgress(), () => this.onProgress(), () =>
            {
                this.onProgress();
                this.onChange();
            });
        }
    }

    configureImagePreview(file: File)
    {
        if (this.imagePreview)
        {
            this.imagePreview.configure(file);
        }
    }

    getFile(): FileInfo
    {
        return this.file;
    }

    isRemoved(): boolean
    {
        return this.isControlRemoved;
    }

    remove()
    {
        if (this.file.hasUploader())
        {
            this.file.getUploader().cancel();
        }
        this.imagePreview?.dispose();
        this.container.remove();
        this.isControlRemoved = true;
        this.onChange();
    }

    private onProgress()
    {
        if (this.progressControls && this.file.hasUploader())
        {
            this.progressControls.onProgress(this.file.getUploader());
        }
    }
}
